import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { PayoutService } from '../../_services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../../_helpers/index';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription, of } from 'rxjs';
import { PayoutCommerceConfigurationExportTemplate, PayoutDetails, PayoutInvoiceList } from '../../_models';
import { AccountTypeOptions } from 'src/app/sharedcomp/constans/routes.constans';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { error } from 'console';

@Component({
  selector: 'app-payoutprocesscommerceview',
  templateUrl: './payoutprocesscommerceview.component.html',
  styleUrls: ['./payoutprocesscommerceview.component.css', '../../../assets/css/customer-list-table.css']
})
export class PayoutprocesscommerceviewComponent implements OnInit {
  payoutProcessId: string;
  customerPublicId: string;
  userPublicId: string;

  isConfirmButtonActive: boolean = false;

  status: string;
  payoutProcessDetails: PayoutDetails;
  name: string;
  created: string;
  reference: string;
  gross_amount: number;
  gross_amount_symbol: string;
  net_amount: number;
  net_amount_symbol: string;
  confirm_payout: string;

  offsetTimeZone: number;
  offsetMinutes: number = 0;
  offsetTimeVal: number;

  dataSource: MatTableDataSource<PayoutInvoiceList> = new MatTableDataSource([]);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['metadata.created', 'resource_related.type', 'metadata.external_id', 'metadata.customer.name', 'total.value', 'to_account.bank.name', 'to_account.account_number', 'status', 't_cta', 'external_id', 'actions'];

  payoutSelected: { customer_public_id: string; payout_public_id: string; };

  @ViewChild('newWindow') newWindow: any;
  modalRef: BsModalRef;

  totalResultSize: number;
  pageSize: number = 0;
  pageIndex: number = 0;
  pageStart: number = 0;
  invoiceStatus: string = '';
  PageSizeOptions: number[];

  getPayoutDetails$: Subscription;

  timerId: any;
  export_templates_list: PayoutCommerceConfigurationExportTemplate[];
  private destroy$ = new Subject<void>();

  constructor(
    private payoutService: PayoutService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private modalService: BsModalService
  ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setUserId();
    this.setTimeData();

    let params: any = this.activatedRoute.snapshot.params;
    this.payoutProcessId = params.id;
    this.getConfiguration();
    this.getPayoutCommerceDetails();
    this.getInvoiceListFromPayout();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    clearTimeout(this.timerId);
    if (this.getPayoutDetails$ && !this.getPayoutDetails$.closed) {
      this.getPayoutDetails$.unsubscribe();
    }
  }

  setUserId() {
    let browserStorage;
    let browserStorage1 = localStorage.getItem('application');
    if (browserStorage1 === 'PAYOUTS') {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage === '' || browserStorage === undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    }
    this.userPublicId = localStorage.getItem('userId');
  }

  setTimeData() {
    let browserStorage;
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === undefined || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
    } else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
    }

    this.offsetTimeVal = (this.offsetTimeZone * 3600000);
    AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal.toString();
  }

  getConfiguration() {
    this.payoutService.getPayoutServiceOpsConfiguration(this.customerPublicId).subscribe(data => {
      this.export_templates_list = data.values.detail.export_templates;
    }, error => {
      console.error('Failed while trying to get export templates.' + error);
    })
  }

  exportTemplate(template: string) {
    this.spinnerService.show();
    this.payoutService.downloadFilePayout(this.customerPublicId, this.payoutProcessId, template).subscribe(data => {
      const storageUrl = data.body.storage_url;
      if (storageUrl !== undefined) {
        location.href = storageUrl;
      } else {
        console.error('Failed while trying to export invoice list from payout detail.');
      }
      this.spinnerService.hide();
    }, error => {
      this.spinnerService.hide();
      console.error('Failed while trying to export invoice list from payout detail.' + error);
    })
  }

  getPayoutCommerceDetails() {
    clearTimeout(this.timerId);
    this.getPayoutDetails$ = this.payoutService.getPayoutProcessDetails(this.payoutProcessId).subscribe({
      next: data => {
        this.payoutProcessDetails = data;
        this.name = this.payoutProcessDetails.name;
        this.created = this.payoutProcessDetails.created;
        this.reference = this.payoutProcessDetails.reference;
        this.gross_amount = this.payoutProcessDetails.gross_amount.value;
        this.gross_amount_symbol = this.payoutProcessDetails.gross_amount.symbol;
        this.net_amount = this.payoutProcessDetails.net_amount.value;
        this.net_amount_symbol = this.payoutProcessDetails.net_amount.symbol;
        this.status = this.payoutProcessDetails.status;
        let activity_list = this.payoutProcessDetails.activity_list.filter(item => item.status === 'COMPLETED');
        this.isConfirmButtonActive = this.status === 'PROCESSING';
        if (this.isConfirmButtonActive) {
          this.payoutSelected = {
            customer_public_id: this.payoutProcessDetails.company.public_id,
            payout_public_id: this.payoutProcessDetails.public_id
          }
        }
        if (activity_list.length > 0) {
          this.confirm_payout = activity_list[0].created;
        }
        this.spinnerService.hide();
      },
      error: err => {
        console.error('Failed! while trying to get the getPayoutProcessDetails. ' + err)
      },
      complete: () => {
        if (this.status === 'PROCESSING') {
          this.getPayoutDetails$.unsubscribe();
          this.timerId = setTimeout(() => {
            this.getPayoutCommerceDetails();
          }, 60000);
        }
      }
    })
  }

  getInvoiceListFromPayout() {
    this.payoutService.getInvoiceListFromPayout(this.payoutProcessId, this.pageSize, this.pageStart, this.invoiceStatus)
    .pipe(
      takeUntil(this.destroy$),
      tap(invoices => {
        const resources = invoices.data;
        this.dataSource.data = resources;
        this.totalResultSize = invoices.records;
        this.spinnerService.hide();
      }),
      catchError(error => {
        console.error('Failed! while trying to get the get invoice list. ' + error)
        this.spinnerService.hide();
        return of(null);
      })
    )
    .subscribe();
  }

  filterStatusDetails(status: string) {
    if (this.invoiceStatus !== status) {
      this.spinnerService.show();
      this.invoiceStatus = status;
      this.pageStart = 0;
      this.pageIndex = 0;
      this.paginator.pageIndex = 0;
      this.getInvoiceListFromPayout();
    }
  }

  goToInvoiceDetails(publicId: string) {
    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      return this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${publicId}/view`]);
    }
  }

  viewInvoiceDetailsAction(publicId: string) {
    this.spinnerService.show();
    this.goToInvoiceDetails(publicId);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  hideModal(reason: 'accept' | '' = ''): void {
    if (reason === 'accept') {
      const { customer_public_id, payout_public_id } = this.payoutSelected;
      this.router.navigate(['/payout_process_commerce/confirm', customer_public_id, payout_public_id]);
    }
    this.modalRef.hide();
  }

  gridPageChange(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getInvoiceListFromPayout();
  }

}
